<template>
<div id="loaderBox">
	<div id="loader" >
	<img src="@/assets/images/loader.gif" />
	</div>
</div>
</template>
<script>
export default {};
</script>

<style scoped>
#loaderBox {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background: white;
    z-index: 10;
}
#loader{
    display: flex;
    justify-content: center;
}
</style>
